var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_19517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.22656 7.5L8.4375 10L12.7188 5M8.97266 14.5C7.98877 14.5 7.01451 14.3189 6.10552 13.9672C5.19653 13.6154 4.37059 13.0998 3.67488 12.4497C2.97917 11.7997 2.4273 11.0281 2.05078 10.1788C1.67426 9.32951 1.48047 8.41925 1.48047 7.5C1.48047 6.58075 1.67426 5.6705 2.05078 4.82122C2.4273 3.97194 2.97917 3.20026 3.67488 2.55025C4.37059 1.90024 5.19653 1.38463 6.10552 1.03284C7.01451 0.68106 7.98877 0.5 8.97266 0.5C10.9597 0.5 12.8654 1.2375 14.2704 2.55025C15.6755 3.86301 16.4648 5.64348 16.4648 7.5C16.4648 9.35652 15.6755 11.137 14.2704 12.4497C12.8654 13.7625 10.9597 14.5 8.97266 14.5Z",
    stroke: "black",
    strokeWidth: 1.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_19517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.0547,
    height: 15,
    fill: "white",
    transform: "translate(0.945312)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.92f542db7017d940c4ed2fd64b719ebb.svg";
export { ForwardRef as ReactComponent };